import { IColumnFromArrayDetailField, ICustomColumn, IEdge, setColumnsFromArray } from './setColumnsFromArray';
import {
  FilterOperation,
  IProductWorkspaceHelperQueryResult,
  IProductWorkspaceHelperQueryVariables,
  Maybe,
} from '../graphql/schema/p4types';
import { useQuery } from '@apollo/client';
import productWorkspaceHelperQuery from '../graphql/queries/product/ProductWorkspaceHelperQuery.graphql';
import { useMemo } from 'react';

// <b>Developer note</b>: If adding to a workspace, change preProcessFilters in the appropriate services class to process warehouse filters
export const useWarehouseColumns = (
  fieldName: string,
  detailFields: Array<IColumnFromArrayDetailField>
): Maybe<{ [key: string]: ICustomColumn }> => {
  //We specify to include archived in this query because the ProductWarehouseDetails records against the product will also include archived.
  //The 'setColumnsFromArray' function should appropriately filter them out from actual availability as columns.
  const { data } = useQuery<IProductWorkspaceHelperQueryResult, IProductWorkspaceHelperQueryVariables>(
    productWorkspaceHelperQuery,
    {
      variables: {
        filters: [
          {
            filterParameters: {
              field: 'archived',
              value: 'false',
            },
            filterOperation: FilterOperation.Equals,
          },
          {
            filterParameters: {
              field: 'archived',
              value: 'true',
            },
            filterOperation: FilterOperation.Equals,
          },
        ],
      },
      fetchPolicy: 'network-only',
    }
  );

  return useMemo(() => {
    if (!data?.warehouses?.edges) return null;
    return setColumnsFromArray(
      fieldName,
      data.warehouses.edges! as Array<IEdge>,
      'description',
      detailFields,
      'BigDecimal'
    );
  }, [data?.warehouses?.edges, detailFields, fieldName]);
};

export default useWarehouseColumns;
